import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import jsRedirect from '../../../helpers/jsRedirect';
import { Row, Col } from '../../base/Grid';
import AssistiveText from '../../base/AssistiveText';
import {
  BGImageContainerExperienceCalloutStyled,
  ButtonExperienceCalloutStyled,
  ButtonOverlayStyled,
  ColExperienceCalloutStyled,
  ComponentContainerExperienceCalloutStyled,
  ContainerExperienceCalloutStyled,
  CTAContainerExperienceCalloutStyled,
  DescriptionCopyTypographyStyled,
  ImageContainerExperienceCalloutStyled,
  PictureExperienceCalloutStyled,
  SectionExperienceCalloutStyled,
  TypographyTitleStyled,
  Styles,
} from './styles';

export const ExperienceCalloutComponent = ({
  actionId,
  assistiveText,
  buttonText,
  copy,
  icon,
  id,
  image,
  imageAlt,
  isFullWidth,
  title,
  url,
  variant,
  withBGImage,
  withHoverShadow,
  moduleName,
}) => {
  const styles = Styles();
  const IconToRender = icon;
  return (
    <SectionExperienceCalloutStyled
    id={id}
    variant={variant}
    hasFullWidthContainer={isFullWidth}
    data-module={`${id}:${moduleName}:A`}>
      <ContainerExperienceCalloutStyled
      variant={variant}
      isFullWidthContainer={isFullWidth}
      withBGImage={withBGImage}>
        <ComponentContainerExperienceCalloutStyled
        variant={variant}
        isFullWidthContainer={isFullWidth}
        withHoverShadow={withHoverShadow}>
          <Row align="center">
            <ColExperienceCalloutStyled xsmall={12} medium={5}>
              {/* Background image */}
              {withBGImage ? (
                <BGImageContainerExperienceCalloutStyled
                forFullWidthContainer={isFullWidth}
                data-bg={`url(${image})`} /* If a non URL image is passed in, how should we handle setting the data-bg? */
                className="lazy"
                image={image} />
              ) : (
                <ImageContainerExperienceCalloutStyled
                forFullWidthContainer={isFullWidth}>
                  {icon ? (
                    <IconToRender style={styles.IconExperienceCalloutStyled} />
                  ) : (
                    <PictureExperienceCalloutStyled src={image} alt={imageAlt} />
                  )}
                </ImageContainerExperienceCalloutStyled>
              )}
            </ColExperienceCalloutStyled>
            <Col align='center' xsmall={12} medium={7}>
              <CTAContainerExperienceCalloutStyled withBGImage={withBGImage}>
                <TypographyTitleStyled
                component='h2'
                disableBottomPadding>
                  {title}
                </TypographyTitleStyled>
                {copy && <DescriptionCopyTypographyStyled component='p' disableBottomPadding>{copy}</DescriptionCopyTypographyStyled>}
                <ButtonExperienceCalloutStyled
                id={`${id}-button`}
                className={variant !== 'primary' && 'button-experience-callout-styled'}
                variantOverride={variant}
                role="link"
                type="button"
                onClick={() => {
                  jsRedirect(url);
                }}>
                  {buttonText}
                </ButtonExperienceCalloutStyled>
              </CTAContainerExperienceCalloutStyled>
            </Col>
            {/* Clickable overlay, with drop shaodw, for the in-page variation */}
            {!isFullWidth && (
              <ButtonOverlayStyled
              id={actionId}
              role='link'
              data-tracking-id={actionId}
              aria-label={assistiveText}
              onClick={() => {
                jsRedirect(url);
              }}
            >
                <AssistiveText component='span' text={assistiveText} />
              </ButtonOverlayStyled>
            )}
          </Row>
        </ComponentContainerExperienceCalloutStyled>
      </ContainerExperienceCalloutStyled>
    </SectionExperienceCalloutStyled>
  );
};

ExperienceCalloutComponent.propTypes = {
  actionId: PropTypes.string,
  assistiveText: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  copy: PropTypes.string,
  icon: PropTypes.any,
  id: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  isFullWidth: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  variant: PropTypes.string,
  withBGImage: PropTypes.bool,
  withHoverShadow: PropTypes.bool,
  /**  Used to populate and define a module on the section for a given page, used in adobe. (Ex: hero, intro-callout, content-hub) */
  moduleName: PropTypes.string,
};

ExperienceCalloutComponent.defaultProps = {
  buttonText: 'Get Started',
  url: 'https://www.google.com/',
  variant: 'tertiary',
  withBGImage: true,
};

export default withTheme(ExperienceCalloutComponent);
